import Button from 'components/button/Button';
import { bgColor, black, blue, textGray } from 'modules/colors';
import media from 'modules/media';
import { fonts, spacing } from 'modules/metrics';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: ${spacing.xl}px;
  max-width: 1280px;
  margin: 0 auto;

  ${media.tablet} {
    padding: ${spacing.xl}px;
  }
`;

export const Header = styled.h2`
  font-size: ${fonts.xl}px;
  color: ${black};
  margin-top: ${spacing.xl}px;
`;

export const HeaderLine = styled.hr`
  background-color: ${textGray};
  height: 2px;
  border: 0;
  width: 100%;
  margin: ${spacing.md}px 0 ${spacing.xl}px 0;
`;

export const Item = styled.div`
  font-size: ${fonts.md}px;
  line-height: 27px;
  letter-spacing: -0.1px;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: ${bgColor};
  }
`;

export const Question = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  cursor: pointer;
  color: ${black};
  font-weight: 500;
`;

export const Text = styled.div`
  width: 100%;

  ${media.phone} {
    width: 75%;
  }
`;

export const Icon = styled.div`
  position: relative;
  width: 16px !important;
  height: 16px !important;
  &::before,
  &::after {
    content: '';
    position: absolute;
    background-color: ${blue};
    transition: -webkit-transform 0.25s ease-out;
    transition: transform 0.25s ease-out;
    transition: transform 0.25s ease-out, -webkit-transform 0.25s ease-out;
  }
  &::before {
    top: 0;
    left: 50%;
    width: 2px;
    height: 100%;
    margin-left: -1px;
    ${(props) => props.open && 'transform: rotate(90deg)'};
  }
  &::after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    margin-top: -1px;
  }
`;

export const Answer = styled.div`
  display: ${(props) => (props.show ? 'block' : 'none')};
  margin-bottom: 24px;

  > a {
    color: ${blue};
  }
`;

export const ButtonStyled = styled(Button)`
  margin: 0 auto;
  margin-top: 32px;
`;
